import { lazy } from 'react';

const Home = lazy(() => import('pages/Home'));
const Browse = lazy(() => import('pages/Browse'));
const Analytics = lazy(() => import('pages/Analytics'));
const About = lazy(() => import('pages/About'));
//-------------------------------------------------------

export const ROUTE_TYPE = {
  PRIVATE: 0,
  PUBLIC: 1,
};

const routes = [
  {
    path: '/',
    component: Home,
    type: ROUTE_TYPE.PUBLIC,
  },
  {
    path: '/browse',
    component: Browse,
    type: ROUTE_TYPE.PUBLIC,
  },
  {
    path: '/analytics',
    component: Analytics,
    type: ROUTE_TYPE.PUBLIC,
  },
  {
    path: '/about',
    component: About,
    type: ROUTE_TYPE.PUBLIC,
  },
];

export default routes;
